import type { PrivateEventDetail } from '../../api/privateEvents';

/** "Deposit paid" with the payment id as plain text. A payment has no page of
 *  its own, so the HubSpot deal link beside it is how it is opened. An unticked
 *  box means "not recorded here", never "unpaid", so nothing shows. */
export default function ClientDealDeposit({ event }: { event: PrivateEventDetail }) {
  if (!event.depositReceived) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-ink-2)' }}>Deposit paid</span>
      {event.hubspotPaymentId && (
        <span className="nb-tabular" style={{ fontSize: 11.5, color: 'var(--nb-muted)' }}>
          Payment {event.hubspotPaymentId}
        </span>
      )}
    </div>
  );
}
